/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PracticeBaseService } from '../practice-base-service';
import { PracticeApiConfiguration } from '../practice-api-configuration';
import { PracticeStrictHttpResponse } from '../practice-strict-http-response';

import { facilityClinicGroupIdIdGet } from '../fn/facility/facility-clinic-group-id-id-get';
import { FacilityClinicGroupIdIdGet$Params } from '../fn/facility/facility-clinic-group-id-id-get';
import { facilityClinicGroupIdIdUpdateStatusStatusPost } from '../fn/facility/facility-clinic-group-id-id-update-status-status-post';
import { FacilityClinicGroupIdIdUpdateStatusStatusPost$Params } from '../fn/facility/facility-clinic-group-id-id-update-status-status-post';
import { facilityClinicGroupIdPractitionersFacilityIdPost } from '../fn/facility/facility-clinic-group-id-practitioners-facility-id-post';
import { FacilityClinicGroupIdPractitionersFacilityIdPost$Params } from '../fn/facility/facility-clinic-group-id-practitioners-facility-id-post';
import { facilityLinkDevicePost } from '../fn/facility/facility-link-device-post';
import { FacilityLinkDevicePost$Params } from '../fn/facility/facility-link-device-post';
import { facilityLinkPractitionerPost } from '../fn/facility/facility-link-practitioner-post';
import { FacilityLinkPractitionerPost$Params } from '../fn/facility/facility-link-practitioner-post';
import { facilityLinkPractitionersPost } from '../fn/facility/facility-link-practitioners-post';
import { FacilityLinkPractitionersPost$Params } from '../fn/facility/facility-link-practitioners-post';
import { FacilityModel } from '../models/facility-model';
import { facilityPost } from '../fn/facility/facility-post';
import { FacilityPost$Params } from '../fn/facility/facility-post';
import { facilityUnLinkDevicePost } from '../fn/facility/facility-un-link-device-post';
import { FacilityUnLinkDevicePost$Params } from '../fn/facility/facility-un-link-device-post';
import { facilityUnLinkPractitionerPost } from '../fn/facility/facility-un-link-practitioner-post';
import { FacilityUnLinkPractitionerPost$Params } from '../fn/facility/facility-un-link-practitioner-post';
import { PractitionerModel } from '../models/practitioner-model';

@Injectable({ providedIn: 'root' })
export class PracticeFacilityService extends PracticeBaseService {
  constructor(config: PracticeApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `facilityClinicGroupIdIdGet()` */
  static readonly FacilityClinicGroupIdIdGetPath = '/Facility/{clinicGroupId}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityClinicGroupIdIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdIdGet$Response(params: FacilityClinicGroupIdIdGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<FacilityModel>> {
    const obs = facilityClinicGroupIdIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityClinicGroupIdIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdIdGet(params: FacilityClinicGroupIdIdGet$Params, context?: HttpContext): Observable<FacilityModel> {
    const resp = this.facilityClinicGroupIdIdGet$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<FacilityModel>): FacilityModel => r.body)
    );
  }

  /** Path part for operation `facilityPost()` */
  static readonly FacilityPostPath = '/Facility';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityPost$Response(params?: FacilityPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<string>> {
    const obs = facilityPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityPost(params?: FacilityPost$Params, context?: HttpContext): Observable<string> {
    const resp = this.facilityPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `facilityClinicGroupIdIdUpdateStatusStatusPost()` */
  static readonly FacilityClinicGroupIdIdUpdateStatusStatusPostPath = '/Facility/{clinicGroupId}/{id}/UpdateStatus/{status}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityClinicGroupIdIdUpdateStatusStatusPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdIdUpdateStatusStatusPost$Response(params: FacilityClinicGroupIdIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityClinicGroupIdIdUpdateStatusStatusPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityClinicGroupIdIdUpdateStatusStatusPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdIdUpdateStatusStatusPost(params: FacilityClinicGroupIdIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityClinicGroupIdIdUpdateStatusStatusPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilityClinicGroupIdPractitionersFacilityIdPost()` */
  static readonly FacilityClinicGroupIdPractitionersFacilityIdPostPath = '/Facility/{clinicGroupId}/Practitioners/{facilityId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityClinicGroupIdPractitionersFacilityIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdPractitionersFacilityIdPost$Response(params: FacilityClinicGroupIdPractitionersFacilityIdPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PractitionerModel>>> {
    const obs = facilityClinicGroupIdPractitionersFacilityIdPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityClinicGroupIdPractitionersFacilityIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  facilityClinicGroupIdPractitionersFacilityIdPost(params: FacilityClinicGroupIdPractitionersFacilityIdPost$Params, context?: HttpContext): Observable<Array<PractitionerModel>> {
    const resp = this.facilityClinicGroupIdPractitionersFacilityIdPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<Array<PractitionerModel>>): Array<PractitionerModel> => r.body)
    );
  }

  /** Path part for operation `facilityLinkPractitionerPost()` */
  static readonly FacilityLinkPractitionerPostPath = '/Facility/LinkPractitioner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityLinkPractitionerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkPractitionerPost$Response(params?: FacilityLinkPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityLinkPractitionerPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityLinkPractitionerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkPractitionerPost(params?: FacilityLinkPractitionerPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityLinkPractitionerPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilityLinkPractitionersPost()` */
  static readonly FacilityLinkPractitionersPostPath = '/Facility/LinkPractitioners';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityLinkPractitionersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkPractitionersPost$Response(params?: FacilityLinkPractitionersPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityLinkPractitionersPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityLinkPractitionersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkPractitionersPost(params?: FacilityLinkPractitionersPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityLinkPractitionersPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilityUnLinkPractitionerPost()` */
  static readonly FacilityUnLinkPractitionerPostPath = '/Facility/UnLinkPractitioner';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityUnLinkPractitionerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityUnLinkPractitionerPost$Response(params?: FacilityUnLinkPractitionerPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityUnLinkPractitionerPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityUnLinkPractitionerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityUnLinkPractitionerPost(params?: FacilityUnLinkPractitionerPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityUnLinkPractitionerPost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilityLinkDevicePost()` */
  static readonly FacilityLinkDevicePostPath = '/Facility/LinkDevice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityLinkDevicePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkDevicePost$Response(params?: FacilityLinkDevicePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityLinkDevicePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityLinkDevicePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityLinkDevicePost(params?: FacilityLinkDevicePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityLinkDevicePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `facilityUnLinkDevicePost()` */
  static readonly FacilityUnLinkDevicePostPath = '/Facility/UnLinkDevice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `facilityUnLinkDevicePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityUnLinkDevicePost$Response(params?: FacilityUnLinkDevicePost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
    const obs = facilityUnLinkDevicePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `facilityUnLinkDevicePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  facilityUnLinkDevicePost(params?: FacilityUnLinkDevicePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.facilityUnLinkDevicePost$Response(params, context);
    return resp.pipe(
      map((r: PracticeStrictHttpResponse<void>): void => r.body)
    );
  }

}
